import { CloseIcon } from "../../../../assets/svgIcons";
import primaryComponents from "../../../primaryComponents";
import styles from "./styles.module.scss";

export const MenuHeader = ({ title = "", closeModal = () => {} }) => {
  return (
    <div className={styles.menuHeader}>
      <h4 className="mb-0">{title}</h4>

      <primaryComponents.Button
        style={{ padding: "0 10px" }}
        classNames={"btn btn--outline smallBtn"}
        onClick={closeModal}
      >
        <CloseIcon className="mr-1 dark--text" style={{ fontSize: "20px" }} />{" "}
        Close
      </primaryComponents.Button>
    </div>
  );
};
